import { render } from "./DepositsComponent.vue?vue&type=template&id=6590d0b6&scoped=true"
import script from "./DepositsComponent.vue?vue&type=script&lang=js"
export * from "./DepositsComponent.vue?vue&type=script&lang=js"

import "./DepositsComponent.vue?vue&type=style&index=0&id=6590d0b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6590d0b6"]])

export default __exports__